import React from "react";
import "../../../devices/components/DeleteDevice.css";

const DeleteSimulationModal = ({
  open,
  simulation,
  onConfirm,
  onClose,
  loading = false,
}) => {
  if (!open || !simulation) return null;

  return (
    <>
      <div
        className="delete-device-overlay"
        onClick={loading ? undefined : onClose}
      />
      <div
        className="delete-device-popup-container"
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-sim-title"
      >
        <div className="delete-device-header-container">
          <h3 className="delete-device-title" id="delete-sim-title">
            Delete simulation &ldquo;{simulation.simulationName}&rdquo;?
          </h3>
          <button
            className="delete-device-close-button"
            onClick={onClose}
            disabled={loading}
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <div className="delete-device-content-container">
          <p className="delete-device-warning">
            This action cannot be undone. The timeseries, daily-summary, and
            sysconfig files for this simulation run will be permanently removed.
          </p>
        </div>
        <div className="delete-device-form-actions">
          <button
            className="delete-device-cancel-action"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            className="delete-device-delete-button"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-small" /> Deleting&hellip;
              </>
            ) : (
              "Delete simulation"
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default DeleteSimulationModal;
